module.exports = __webpack_public_path__ + "img/960e5b984a99540abf2962ce49a85530.5297a085.png";